export enum CustomMenuItemNameEnum {
    HalfAndHalf = 'Half & Half',
    CreateYourOwn = 'Create Your Own',
    HeartShapedPizza = 'Heart-Shaped Pizza',
    BlockOPizza = 'Block O Pizza',
}
